import { useTrackEventMutation } from 'app/data/mutations/use-track-event-mutation';
import { WebClickProperties, WebClickTrackEvent } from 'app/data/types/tracking/web-click';
import { useCallback } from 'react';

export const useTrackWebClick = () => {
  const { trackEvent } = useTrackEventMutation();

  return useCallback(
    (properties: WebClickProperties) => {
      const eventPayload: WebClickTrackEvent = {
        type: 'action',
        event_type: 'track_v2_web_click',
        properties,
      };
      trackEvent(eventPayload);
    },
    [trackEvent],
  );
};
